import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e5df5140&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5df5140')) {
      api.createRecord('e5df5140', component.options)
    } else {
      api.reload('e5df5140', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e5df5140&", function () {
      api.rerender('e5df5140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gRx526JSnqot/JS/pricehelp.vue"
export default component.exports